module.exports = __webpack_public_path__ + "static/img/4.2be9a80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4.png
// module id = 200
// module chunks = 1